module.exports = __webpack_public_path__ + "static/media/galdisaUSA.152623dc.jpg";